import { RELATION_TYPE_ENUMS } from 'src/utils/constants/BuyPolicy'
import {
  getGenderByType,
  getMaritalStatusByRelationType,
} from 'src/services/buyPolicy/commonService'
import { getAge } from 'src/utils/commonMethods'

const getProposerAndInsuredMemberDetails = (lifeReducerData) => {
  const { userDetails, ageDetails } = lifeReducerData

  let insuredMemberDetails = []

  const proposerDetails = {
    fullName: userDetails.fullName,
    firstName: userDetails.fullName,
    lastName: null,
    dateOfBirth: ageDetails.SELF ?? null,
    email: null,
    phone: userDetails.mobileNumber,
    height: null,
    weight: null,
    panNumber: null,
    aadharNumber: null,
    isNominee: false,
    age: ageDetails.SELF ? getAge(ageDetails.SELF) : null,
    relation: RELATION_TYPE_ENUMS.SELF,
    gender: userDetails.gender,
    maritalStatus: '',
    address: {
      permanentAddress: {
        addressLine: '',
        landmark: '',
        pincode: '',
        city: '',
        state: '',
      },
      currentAddress: {
        addressLine: '',
        landmark: '',
        pincode: '',
        city: '',
        state: '',
      },
      isCurrentAddressPermanent: false,
    },
  }

  userDetails.insuredMembers.forEach((memberDetail, index) => {
    if (memberDetail.value !== 'SELF') {
      insuredMemberDetails.push({
        id: 10001 + index,
        firstName: '',
        lastName: null,
        dateOfBirth: ageDetails[memberDetail.value],
        height: null,
        weight: null,
        isNominee: false,
        age: getAge(ageDetails[memberDetail.value]),
        relation: RELATION_TYPE_ENUMS[memberDetail.value],
        gender: getGenderByType(memberDetail.value),
        maritalStatus: getMaritalStatusByRelationType(memberDetail.value),
      })
    }
  })

  const nomineeDetails = {
    firstName: null,
    lastName: null,
    dateOfBirth: null,
    relation: null,
    gender: null,
  }

  return {
    proposerDetails,
    insuredMemberDetails,
    nomineeDetails,
  }
}

export { getProposerAndInsuredMemberDetails }
